import { RackCellSchema } from "@redotech/redo-model/wms/schema/warehouse-cell";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const binLabelFormatSchema = createEnum(["individual", "sheet", "1x4"]);

export const printBinLabels = {
  name: "printBinLabels" as const,
  input: z.object({
    racks: z.array(RackCellSchema),
    format: binLabelFormatSchema,
  }),
  output: z.object({ url: z.string() }),
};

export type PrintBinLabelsInput = z.infer<typeof printBinLabels.input>;
